// scripts/build.ts's `define` writes the instant the build started over this name; nothing declares it at run time.
declare const __BUILD_TIME__: string;

// The minute is as fine as this needs to be — a publication is dated to the day and the time only tells two builds on
// the same day apart — and the spelling is the ISO one the instant already arrives in, with the zone said rather than
// assumed for the same reason /certificate says it: what is written is UTC and what reads it is every other zone.
export const BUILD_DATE = `${__BUILD_TIME__.slice(0, 16).replace("T", " ")} UTC`;

// One sentence, written here and never in a page: four utilities each wording their own claim about their own
// freshness is four different answers to the one question, and the date is the half of it none of them knows.
export function currentAsOf(publications: string): string {
  return `Read from ${publications} when the site was built. Current as of ${BUILD_DATE}.`;
}
